require('./loader.css');

/* globals $, game */

$.ready(function() {
	/* globals base */
	var body = $(document.body).addClass('loading loading-0');
	
	var loader = window.loader = $.div('loader').appendTo(body);
	loader.progress = $.div().addClass('progress');
	loader.bar = $.div().appendTo(loader.progress);
	loader.play = $.div().addClass('play').appendTo(loader);
	
	loader.on('click', function() {
		if (!loader.play.hasClass('show') || body.hasClass('done')) {
			return;
		}
		
		game.trigger('ready');
		body.addClass('done');
		
		setTimeout(function() {
			loader.remove();
			body.attr('class', 'done');
		}, 1000);
	});
	
	var tracking = {};
	var counts = {
		total: 0,
		loaded: 0,
	};
	
	loader.start = function(key) {
		tracking[key] = false;
		this.count(true);
	};
	
	loader.stop = function(key) {
		if (body.hasClass('done') || loader.play.hasClass('show')) {
			return;
		}
		
		tracking[key] = true;
		this.count(false);
		
		for (var k in tracking) {
			if (!tracking[k]) {
				return;
			}
		}
		
		finish();
	};
	
	loader.count = function(dir) {
		if (dir === true) {
			counts.total++;
		}
		
		else if (dir === false) {
			counts.loaded++;
		}
		
		var percent = counts.loaded / counts.total;
		loader.bar.css('width', percent * 100 + '%');
	};
	
	loader.loadImages = function() {
		loader.start('images');
		
		var images = getStyleImages();
		
		if (!images.length) {
			setTimeout(function() {
				loader.stop('images');
				phase1();
			}, 250);
			
			return;
		}
		
		var container = $.div().appendTo(game);
		container.loaded = 0;
		
		function loaded() {
			loader.count(false);
			container.loaded++;
			
			if (container.loaded !== images.length) {
				return;
			}
			
			container.remove();
			loader.stop('images');
			phase1();
		}

		for (var i = 0; i < images.length; i++) {
			loader.count(true);
			
			var url = images[i];
			
			var image = new Image();
			
			image.src = url;
			
			image.style.backgroundImage = 'url(' + url + ')';
			image.addEventListener('load',  loaded);
			image.addEventListener('error', loaded);
			
			$(image).appendTo(container);
		}
	};
	
	loader.setRecall = function() {
		this.addClass('mode-recall');
	};
	
	start();
	
	function start() {
		loader.progress.appendTo(loader);
		body.addClass('loading-0');
		
		loader.count(true);
		
		setTimeout(function() {
			phase1();
		}, 3000);
	}
	
	function phase1() {
		if (!phase1.ready) {
			phase1.ready = true;
			
			return;
		}
		
		body.addClass('loading-1').removeClass('loading-0');
		
		loader.count(true);
		loader.count(false);
		
		setTimeout(function() {
			phase2();
		}, 3000);
	}
	
	function phase2() {
		body.addClass('loading-2').removeClass('loading-1');
		
		loader.count(true);
		loader.count(false);
		
		setTimeout(function() {
			finish();
		}, 2000);
	}
	
	function finish() {
		if (!finish.ready) {
			finish.ready = true;
			
			return;
		}
		
		loader.count(false);
		
		loader.play.addClass('show');
		loader.progress.remove();
		
		if (loader.hasClass('mode-recall')) {
			loader.trigger('click');
		}
	}
	
	function getStyleImages() {
		var url = /(https?:\/\/)?([A-Za-z0-9-_\.]+(?::[0-9]+)?)?(\/[A-Za-z0-9-_\/\.]+)?/;
		var images = [];
		var rules = getStyleRules();
		
		for (var i = 0; i < rules.length; i++) {
			var rule = rules[i];
			
			var path = [];
			if (rule.parentStyleSheet.href) {
				path = rule.parentStyleSheet.href.split('/').slice(0, -1);
			}
			
			for (var j = 0; j < rule.style.length; j++) {
				var key = rule.style[j];
				var value = rule.style[key];
				
				if (!value) {
					continue;
				}
				
				if (typeof value !== 'string') {
					continue;
				}
				
				var search = /url\(["']?(.+?)['"]?\)/g;
				var match = null;
				
				while ((match = search.exec(value))) {
					match = match[1].match(url);
					
					if (match[3]) {
						if (match[1] === 'http://' || match[1] === 'https://') {
							match = match.slice(1, 4).join('');
						}
						
						else {
							match = match.slice(2, 4).join('');
							match = path.concat(match).join('/');
						}
					}
					
					else {
						match = match[2];
						match = path.concat(match).join('/');
					}
					
					var extension = match.split('.').pop();
					
					if ([ 'png', 'jpg', 'gif' ].indexOf(extension) === -1) {
						continue;
					}
					
					images.push(match);
				}
			}
		}
		
		return images;
	}
	
	function getStyleRules() {
		var rules = [];
		
		var sheets = window.document.styleSheets;
		
		for (var i = 0; i < sheets.length; i++) {
			var sheetRules = getStyleSheetRules(sheets[i]);
			
			var rule = null;
			while ((rule = sheetRules.shift())) {
				if (rule.styleSheet) {
					sheetRules = getStyleSheetRules(rule.styleSheet).concat(sheetRules);
					continue;
				}
				
				else if (rule.cssRules) {
					sheetRules = getStyleSheetRules(rule).concat(sheetRules);
					continue;
				}
				
				if (!rule.style || !rule.style.length) {
					continue;
				}
				
				rules.push(rule);
			}
		}
		
		return rules;
	}
	
	function getStyleSheetRules(stylesheet) {
		if (stylesheet.disabled) {
			return [];
		}
		
		if (!stylesheet.cssRules) {
			return [];
		}
		
		var media = stylesheet.media && stylesheet.media.mediaText;
		
		if (media && media.length && !window.matchMedia(media).matches) {
			return [];
		}
		
		return Array.prototype.slice.call(stylesheet.cssRules);
	}
});



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/engine/public-src/common/loader/loader.js
 **/